<template lang="pug">
v-container(v-if="amenities.length > 0" fluid class="tw-p-0 tw-m-0")
  v-row(no-gutters align="center" class="tw-pt-4 tw-pb-2")
    v-col(cols="auto")
      span(class="tw-font-semibold tw-text-gray-700 tw-capitalize") {{ $t('Listings.Common.amenities') }}
    v-col(class="px-2")
      v-divider(class="tw-border-solid tw-border-t")
  v-row(no-gutters justify="space-between" class="tw-px-5")
    v-col(v-for="amenities in chunkedAmenityList" :key="amenities.key")
      div(v-for="amenity in amenities" :key="amenity.id" class="tw-pb-2 tw-pr-3")
        span(class="tw-text-sm") {{ amenity.name }}
</template>
<script>
export default {
  props: {
    amenities: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    chunkedAmenityList() {
      let chunkSize = Math.ceil(this.amenities.length / 3);
      return this.lodash.chunk(this.amenities, chunkSize);
    },
  },
};
</script>
